import React from 'react';
import { Text } from '../atoms/Text';

type SectionHeaderProps = {
  id?: string;
  title: string;
  subtitle?: string;
  className?: string;
};

export function SectionHeader({
  id,
  title,
  subtitle,
  className = '',
}: SectionHeaderProps) {
  return (
    <header id={id} className={`mb-8 ${className}`}>
      <Text as="h2" variant="h2" className="mb-1">
        {title}
      </Text>
      {subtitle && (
        <Text variant="muted" className="mt-1">
          {subtitle}
        </Text>
      )}
    </header>
  );
}
